import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black z-50"
}
const _hoisted_2 = { class: "flex flex-col space-y-1 sticky top-0 z-50 px-4 py-5 bg-brand-black border-b border-brand-dark-gray" }
const _hoisted_3 = { class: "flex flex-col pb-5 px-4 justify-center space-y-4 relative" }
const _hoisted_4 = { class: "flex w-full overflow-scroll" }
const _hoisted_5 = { class: "flex flex-col space-y-6 divide-y divide-brand-dark-gray w-full" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_input_checkbox = _resolveComponent("input-checkbox")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "text-white font-medium text-2xl" }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Location", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.save,
                    class: "!text-xl"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                  'text-brand-light-gray' : !_ctx.location,
                  'text-brand-lime' : _ctx.location
                })
                      }, "Save", 2)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (_ctx.busy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("svg", {
                          class: "animate-spin m-auto h-5 w-5 text-brand-lime",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "h-full" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_input_field, {
              id: "locationSearch",
              type: "text",
              modelValue: _ctx.locationName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.locationName) = $event)),
              debounce: 300,
              "clear-input": true,
              counter: false,
              onOnChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateLocationSearch($event))),
              onOnKeyEnter: _cache[2] || (_cache[2] = () => console.log('enter')),
              placeholder: "e.g. Stoke"
            }, null, 8, ["modelValue"]),
            _cache[7] || (_cache[7] = _createElementVNode("div", {
              id: "attribution",
              class: "text-white"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location, locationKey) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex text-white text-lg pt-6",
                    onClick: ($event: any) => (_ctx.chooseLocation(location)),
                    key: locationKey
                  }, _toDisplayString(location.formatted_address), 9, _hoisted_6))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_input_checkbox, {
                name: "display",
                modelValue: _ctx.showOnProfile,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showOnProfile) = $event)),
                "input-type": "toggle",
                option: {
              text: 'Show on my profile',
              value: true
            }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}